import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { Bug, House, RotateCcw } from 'lucide-react';
import { StateCard } from '@/components/common/StateCard';
import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function RouteErrorState({ reset }: ErrorComponentProps) {
  const { reset: resetQueries } = useQueryErrorResetBoundary();

  function handleRetry() {
    resetQueries();
    reset();
  }

  return (
    <StateCard
      icon={Bug}
      tone="danger"
      title="Something went wrong on this page"
      description="The page could not be shown. Try again, and tell the team if it keeps happening."
      fill
      actions={
        <>
          <Button size="sm" onClick={handleRetry} className="gap-1.5">
            <RotateCcw className="size-3.5" />
            Try again
          </Button>
          <Link
            to="/"
            className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-1.5')}
          >
            <House className="size-3.5" />
            Go to dashboard
          </Link>
        </>
      }
    />
  );
}
